import React from 'react'

import { AwardMark } from '../../../components/AwardMark'
import { Card } from '../../../components/Card'
import { Facility as FacilityIcon, Online as OnlineIcon } from '../../../icons'
import { DefaultFacilityCardProps } from '../types'
import { useImageMapper } from '../utils/useImageMapper'

export const DefaultFacilityCard = (props: DefaultFacilityCardProps) => {
  const {
    idGroup = 'facility_',
    id,
    href,
    as,
    external,
    target,
    imageMapper,
    isOnline,
    isFavorited,
    isFavoriteLoading,
    onFavoriteClick,
    name,
    station,
    minimumPoint,
    activities,
    priority,
    awardYear,
  } = props
  const images = useImageMapper(props, imageMapper)
  const icon = !isOnline ? <FacilityIcon gradient /> : <OnlineIcon gradient />
  const handleFavoriteClick = React.useCallback(() => {
    onFavoriteClick?.(id)
  }, [id, onFavoriteClick])

  const facilityLink = {
    href,
    as,
    external,
    target,
  }

  return (
    <Card id={`${idGroup}${id}`}>
      <Card.Image images={images} {...facilityLink} priority={priority} />
      <Card.Content>
        {awardYear !== undefined && (
          <AwardMark year={awardYear} className="mb-1" />
        )}
        <Card.Content.Heading
          icon={icon}
          {...facilityLink}
          isFavorited={isFavorited}
          isFavoriteLoading={isFavoriteLoading}
          onFavoriteClick={onFavoriteClick ? handleFavoriteClick : undefined}
        >
          {name}
        </Card.Content.Heading>
        <Card.Content.Body mt={1}>
          {station} / {minimumPoint}pt~
        </Card.Content.Body>
        <Card.Content.Body>
          {activities
            .map((a) => (typeof a === 'string' ? a : a.name))
            .join(' / ')}
        </Card.Content.Body>
      </Card.Content>
    </Card>
  )
}
